import React, { useState } from 'react'
import { Header, Button, Paragraph, ErrorMark } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import * as UTILS from "../../../app/utils";
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { setMortgageProperty } from '../../../redux/slice/primaryAgencyApplicationSlice';
import { saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING } from '../../../app/errors';
import { agencyApplicationSelector } from '../../../redux/selector/agencyApplicationSelector';

const MORTGAGE_APPLICATION_PROPERTY = "companyType";

export const ConfirmCompanyType = (props) => {

    const { isModal = false, onEditSave = () => {} } = props;
    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const [selectedOption,setSelectedOption] = useState(agencyApplication.businessLicenceData?.companyType);
    const [applicationSaveError, setApplicationSaveError] = useState(false);
    const [validationError, setValidationError] = useState(false)
    const dispatch = useDispatch();
    
    const handleContinue = () => {

        if(typeof selectedOption === 'undefined') {
            setValidationError(true)
            return
        }

        setApplicationSaveError(false);
        setValidationError(false);

        const update = {
            key: MORTGAGE_APPLICATION_PROPERTY,
            value: selectedOption,
        };

        dispatch(setMortgageProperty(update));

        dispatch(saveBusinessLicenceApplicationData(CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,CONST.APPLICATION_MODE_RENEW))
        .then(data => {
            if(isModal) {
                onEditSave()
            } else {
                const nextUrl = CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_FISCAL_DATE;

                dispatch(
                    push({
                        pathname: UTILS.replaceUrlParams(
                            `${CONST.ROUTE_PATH.MRA_APP}${nextUrl}`,
                            CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
                            CONST.APPLICATION_MODE_RENEW
                        )
                    })
                );
            }
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    return (
        <div className={!isModal ? "container" : ""}>
            {!isModal && <TopNavigationBar {...props} />}
            
            <div className="row">
                {!isModal && 
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-company-type-header"
                        header="Confirm company type"
                    />
                </div>}
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-confirm-company-type-text-1"
                        text={[
                            `Please confirm your company type from the list:`,
                        ]}
                    />
                </div>
            </div>
            
            <div className={"row"}>
                <div className={"col-8"}>
                    <fieldset className={"ns-fieldset" + (selectedOption === "no" ? " ns-fieldset-message-error" : "")}>
                        <div className={"ns-radios ns-radios--small"}>
                            <div 
                                key={"mra-renewal-confirm-company-type-corporated"} 
                                className="ns-radios__item"
                                onClick={() => {
                                    setValidationError(false)
                                    setSelectedOption("corporated")
                                }}
                            >
                                <input
                                    className="ns-radios__input"
                                    key={"mra-renewal-confirm-company-type-corporated-input"}
                                    type={"radio"}
                                    value={"corporated"}
                                    checked={selectedOption === "corporated"}
                                    onClick={(e) => {
                                            setValidationError(false)
                                            setSelectedOption(e.target.value)
                                        }
                                    }
                                    id={
                                        "mra-renewal-compliacne-corporated-input"
                                    }
                                    name={"mra-renewal-confirm-company-type-group"}
                                />
                                <label
                                    key={"mra-corporated-label"}
                                    id={
                                    "mra-renewal-confirm-company-type-corporated-label"
                                    }
                                    className="ns-radios__label"
                                    htmlFor={
                                    "mra-renewal-confirm-company-type-corporated-input"
                                    }
                                >
                                    <span className="ns-label-span">
                                        {CONST.COMPANY_TYPES["corporated"]}
                                    </span>
                                </label>
                            </div>
                            <div 
                                key={"mra-renewal-confirm-company-type-partnership"} 
                                className="ns-radios__item"
                                onClick={() => {
                                    setValidationError(false)
                                    setSelectedOption("partnership")
                                }}
                            >
                                <input
                                    className="ns-radios__input"
                                    key={"mra-renewal-confirm-company-type-partnership-input"}
                                    type={"radio"}
                                    value={"partnership"}
                                    checked={selectedOption === "partnership"}
                                    onClick={(e) => {
                                            setValidationError(false)
                                            setSelectedOption(e.target.value)
                                        }
                                    }
                                    id={
                                        "mra-renewal-compliacne-partnership-input"
                                    }
                                    name={"mra-renewal-confirm-company-type-group"}
                                />
                                <label
                                    key={"mra-partnership-label"}
                                    id={
                                    "mra-renewal-confirm-company-type-partnership-label"
                                    }
                                    className="ns-radios__label"
                                    htmlFor={
                                    "mra-renewal-confirm-company-type-partnership-input"
                                    }
                                >
                                    <span className="ns-label-span">
                                        {CONST.COMPANY_TYPES["partnership"]}
                                    </span>
                                </label>
                            </div>
                            <div 
                                key={"mra-renewal-confirm-company-type-solo"} 
                                className="ns-radios__item"
                                onClick={() => {
                                    setValidationError(false)
                                    setSelectedOption("solo")
                                }}
                            >
                                <input
                                    className="ns-radios__input"
                                    key={"mra-renewal-confirm-company-type-solo-input"}
                                    type={"radio"}
                                    value={"solo"}
                                    checked={selectedOption === "solo"}
                                    onClick={(e) => {
                                            setValidationError(false)
                                            setSelectedOption(e.target.value)
                                        }
                                    }
                                    id={
                                        "mra-renewal-compliacne-solo-input"
                                    }
                                    name={"mra-renewal-confirm-company-type-group"}
                                />
                                <label
                                    key={"mra-solo-label"}
                                    id={
                                    "mra-renewal-confirm-company-type-solo-label"
                                    }
                                    className="ns-radios__label"
                                    htmlFor={
                                    "mra-renewal-confirm-company-type-solo-input"
                                    }
                                >
                                    <span className="ns-label-span">
                                        {CONST.COMPANY_TYPES["solo"]}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>

            <div className="row">
                <div className={`col-lg-8 ${validationError ? "has-error" : "" }`}>
                    <div className="col-xs-3">
                        <Button
                        className="btn-lg btn-default"
                        buttonType={"regular_primary"}
                        text={!isModal ? "Continue" : "Save and close"}
                        onClick={handleContinue}
                        />
                        {(applicationSaveError || validationError)  && ErrorMark()}
                        {applicationSaveError && (
                        <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>
                        )}
                        {validationError && (
                        <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {"Please select one option"}
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}